import HttpService from './http.service';
import {
  getPartNumberString,
  getDivisionMembersFromStep
} from './tactonService';

const getContentSyndicationData = (
  sessionData,
  startData,
  uniquePartIdentifier
) => {
  var data = new Object();
  var selections = [];
  data.division = sessionData.manufacturingDivision;
  data.configmodel = sessionData.configModel;
  data.seriesname = sessionData.seriesName;
  data.selectionModel = [];
  if (startData.isManifoldProduct) data.partnumber = uniquePartIdentifier;
  else data.partnumber = getPartNumberString(startData);
  selections = getDivisionMembersFromStep(startData);

  selections = selections.filter(
    selection => selection.hidden == 'no' && selection.domainName != 'function'
  );
  for (var i = 0; i < selections.length; i++) {
    data.selectionModel.push({
      key: selections[i].name,
      value: selections[i].valueDescription
    });
  }
  return data;
};

const gatewayAPI = async (URL, partNumber) => {
  var response = await HttpService.getAll(`${URL}\\${partNumber}`);
  return response.data;
};

export { getContentSyndicationData, gatewayAPI };
